import {Ease, TweenParams} from "../../core/Animatable";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class FromAnimation extends Animation {

    private readonly targetId: string;
    private readonly bezier: boolean;
    private readonly method: "tweenFrom" | "tweenTo";

    constructor(targetId: string, bezier: boolean, inverse?: boolean) {
        super();
        this.targetId = targetId;
        this.bezier = bezier;
        this.method = inverse ? "tweenTo" : "tweenFrom";
    }

    public animate(item: SceneItem, context: AnimationContext, cb: () => void): void {
        const target = context.scene.collectFromItems((it, items: SceneItem[]) => {
            if (it instanceof SceneItem && it.animationObj && it.animationObj.id === this.targetId) {
                items.push(it);
            }
        })[0];
        if (target) {
            const appear = this.appear && this.delay;
            const params: TweenParams<SceneItem> = {
                scaleX: target.scale.x,
                scaleY: target.scale.y,
                x: target.x,
                y: target.y,
                rotation: target.rotation,
                delay: this.delay,
                repeat: this.repeat,
                yoyo: this.yoyo,
                onStart: appear ? () => {
                    item.paperCutVisible(true);
                    item.alpha = 1;
                } : undefined,
                onUpdate: () => {
                    this.updatePaperCut(item);
                    this.onUpdate();
                },
                onComplete: () => {
                    this.onComplete();
                    cb();
                },
            };
            if (this.bezier) {
                params.bezier = {
                    type: "soft",
                    values: [
                        {x: item.x, y: target.y},
                        {x: target.x, y: target.y},
                    ],
                };
                delete params.x;
                delete params.y;
            }
            item[this.method](this.time || 0.6, this.getEase(Ease.sineOut), params);
            if (appear) {
                item.alpha = 0;
                item.paperCutVisible(false);
            } else if (this.delay) {
                this.updatePaperCut(item);
            }
        } else {
            cb();
        }
    }
}
